/**
 * @fileoverview gRPC-Web generated client stub for auth
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.3
// source: src/grpc/auth.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.auth = require('./auth_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.auth.AuthClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.auth.AuthPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.auth.TokenRequest,
 *   !proto.auth.TokenReply>}
 */
const methodDescriptor_Auth_GetToken = new grpc.web.MethodDescriptor(
  '/auth.Auth/GetToken',
  grpc.web.MethodType.UNARY,
  proto.auth.TokenRequest,
  proto.auth.TokenReply,
  /**
   * @param {!proto.auth.TokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.auth.TokenReply.deserializeBinary
);


/**
 * @param {!proto.auth.TokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.auth.TokenReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.auth.TokenReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.auth.AuthClient.prototype.getToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/auth.Auth/GetToken',
      request,
      metadata || {},
      methodDescriptor_Auth_GetToken,
      callback);
};


/**
 * @param {!proto.auth.TokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.auth.TokenReply>}
 *     Promise that resolves to the response
 */
proto.auth.AuthPromiseClient.prototype.getToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/auth.Auth/GetToken',
      request,
      metadata || {},
      methodDescriptor_Auth_GetToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.auth.TokenRefresh,
 *   !proto.auth.TokenReply>}
 */
const methodDescriptor_Auth_RefreshToken = new grpc.web.MethodDescriptor(
  '/auth.Auth/RefreshToken',
  grpc.web.MethodType.UNARY,
  proto.auth.TokenRefresh,
  proto.auth.TokenReply,
  /**
   * @param {!proto.auth.TokenRefresh} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.auth.TokenReply.deserializeBinary
);


/**
 * @param {!proto.auth.TokenRefresh} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.auth.TokenReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.auth.TokenReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.auth.AuthClient.prototype.refreshToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/auth.Auth/RefreshToken',
      request,
      metadata || {},
      methodDescriptor_Auth_RefreshToken,
      callback);
};


/**
 * @param {!proto.auth.TokenRefresh} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.auth.TokenReply>}
 *     Promise that resolves to the response
 */
proto.auth.AuthPromiseClient.prototype.refreshToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/auth.Auth/RefreshToken',
      request,
      metadata || {},
      methodDescriptor_Auth_RefreshToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.auth.TokenRevoke,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Auth_RevokeToken = new grpc.web.MethodDescriptor(
  '/auth.Auth/RevokeToken',
  grpc.web.MethodType.UNARY,
  proto.auth.TokenRevoke,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.auth.TokenRevoke} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.auth.TokenRevoke} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.auth.AuthClient.prototype.revokeToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/auth.Auth/RevokeToken',
      request,
      metadata || {},
      methodDescriptor_Auth_RevokeToken,
      callback);
};


/**
 * @param {!proto.auth.TokenRevoke} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.auth.AuthPromiseClient.prototype.revokeToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/auth.Auth/RevokeToken',
      request,
      metadata || {},
      methodDescriptor_Auth_RevokeToken);
};


module.exports = proto.auth;

